export default __webpack_public_path__ + "images/0x911da02c1232a3c3e1418b834a311921143b04d7.png";